import { PrismicNextImage } from '@prismicio/next';
import { asText, Content, isFilled } from '@prismicio/client';

import {
  Box,
  Heading,
  Typography,
  Disclosure,
  DisclosureBody,
  DisclosureSummary,
} from '@preventx/oxygen';
import { RichText, defaultEnv, toShortDate } from '@preventx/prismic-services';

// Services
import { applicationEnv } from '@/services/env/shared';

export type WithSupportFAQsProps = {
  id: string;
  slice: Content.RegionComplexSliceWithSimpleFaqsAndReviewer;
};

export const WithSupportFAQs = ({ id, slice }: WithSupportFAQsProps) => {
  const { primary } = slice;
  const {
    faqs,
    title,
    eyebrow,
    caption,
    avatar_image,
    avatar_caption,
    last_updated_date,
    last_updated_label,
  } = primary;

  const { WebsiteUrl } = applicationEnv();

  return (
    <Box addSwitcher component="div">
      <Box addFlow component="header">
        <Typography component="span" addEyebrow colour="primary">
          {asText(eyebrow)}
        </Typography>

        <Heading component="h2" addHeadlineTitle>
          {asText(title)}
        </Heading>

        <RichText content={caption} variant="default" websiteUrl={WebsiteUrl} />

        <Box addCluster component="div" className="flex-nowrap">
          <div className="avatar" data-size="lg">
            <div className="avatar__img">
              <PrismicNextImage field={avatar_image} />
            </div>
          </div>

          <Box component="article">
            <RichText
              variant="default"
              websiteUrl={WebsiteUrl}
              content={avatar_caption}
            />
            <Typography component="p">
              {isFilled.keyText(last_updated_date) &&
                isFilled.richText(last_updated_label) && (
                  <Typography component="small">
                    {asText(last_updated_label)}
                    <Typography component="time">
                      {toShortDate(last_updated_date, defaultEnv.CountryCode)}
                    </Typography>
                  </Typography>
                )}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box addFlow component="div">
        {faqs.map(({ title, content }, index) => {
          const baseKey = `support-faqs-${id}`;

          return (
            <Disclosure
              name={baseKey}
              variant="primary"
              open={faqs.length === 1}
              key={`${baseKey}-${index + 1}`}
            >
              <DisclosureSummary>
                <Heading component="h3" size="h4">
                  {asText(title)}
                </Heading>
              </DisclosureSummary>

              <DisclosureBody>
                <RichText
                  content={content}
                  variant="default"
                  websiteUrl={WebsiteUrl}
                />
              </DisclosureBody>
            </Disclosure>
          );
        })}
      </Box>
    </Box>
  );
};
